import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-hover group" }
const _hoisted_2 = { class: "flex flex-col gap-3 sm:gap-4" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "text-base font-medium text-stone-800 dark:text-stone-200" }
const _hoisted_5 = { class: "mt-2 text-sm text-stone-600 dark:text-stone-400 leading-relaxed" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "mt-3 flex flex-wrap gap-2"
}

import { Project } from "@/types/projectType";
import CustomText from "@/components/common/CustomText.vue";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectList',
  props: {
    project: {}
  },
  setup(__props: any) {

const props = __props;

const techPills = computed(() => {
  return props.project.technologies?.map((t) => t.name).filter(Boolean) || [];
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: `/project/${__props.project.slug}`,
            class: "inline-flex items-center gap-1 group-hover:text-stone-900 dark:group-hover:text-stone-100 transition-colors"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.project.name) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("svg", {
                class: "w-4 h-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5",
                  d: "M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                })
              ], -1))
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(CustomText, {
            value: __props.project.shortDescription
          }, null, 8, ["value"])
        ]),
        (__props.project.projectUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("a", {
                href: __props.project.projectUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "link-arrow text-sm font-medium"
              }, " View Live Project ", 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        (techPills.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(techPills.value, (tech) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: tech,
                  class: "inline-flex items-center px-3 py-1 rounded-full bg-stone-100 dark:bg-stone-800 text-xs font-medium text-stone-700 dark:text-stone-300"
                }, _toDisplayString(tech), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})